"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Handler_1 = require("./Handler");
const ChildList_1 = require("./ChildList");
class ChildrenHandler extends Handler_1.Handler {
    handle(obj, settings) {
        const childList = new ChildList_1.ChildList(obj);
        childList.patch(settings);
    }
}
exports.ChildrenHandler = ChildrenHandler;
//# sourceMappingURL=ChildrenHandler.js.map